import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule, formatDate } from '@angular/common';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { EjecucionService } from '../../../services/ejecucion.service';
import { I18n, CustomDatepickerI18n } from '../../../clases/idioma-fecha';

@Component({
  selector: 'app-plan-evaluacion',
  standalone: true,
  imports: [CommonModule, ModalComponent, FormsModule, NgbDatepickerModule, NgxMaskDirective, ReactiveFormsModule],
  templateUrl: './plan-evaluacion.component.html',
  styleUrl: './plan-evaluacion.component.css',
  providers: [
    provideNgxMask(),
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
})
export class PlanEvaluacionComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Input() id_accion_formativa?: any;
  @Input() id_oferta_formativa?: any;
  @Input() nombre_oferta?: any;
  @Input() uc_pre_impreso?: any;
  @Output() vuelve = new EventEmitter<any>();

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  resultado: any = [];
  //filteredResultado: any[] = []; // Nuevo array para los resultados filtrados
  errorMessage: string = '';
  fechaActual: string = '';
  total: number = 0;

  // 1. Declarar las propiedades para los límites de fecha
  fechaSeleccionada!: NgbDateStruct;

  formularioPlanEvaluacion: FormGroup;

  private srvLogin = inject(InicioService);
  private servicios = inject(EjecucionService);
  private fb = inject(FormBuilder);

  constructor(){

    this.srvLogin.user$.subscribe(user => { this.user = user; });

    this.formularioPlanEvaluacion = this.fb.group({
      id_accion_formativa: new FormControl('', [Validators.required]),
      id_facilitador: new FormControl(this.user.id_institucional, [Validators.required]),
      plan_evaluacion: this.fb.array([])
    });
  }

  ngOnInit(): void {
    console.log('asdasd:   ', this.user.id_institucional)
    const fecha = new Date();
    this.fechaActual = formatDate(fecha, 'dd-MM-yyyy', 'en-US'); // Formato: día/mes/año
  }

  get plan_evaluacion() {
    return this.formularioPlanEvaluacion.get("plan_evaluacion") as FormArray
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.planEvaluacion(this.id_accion_formativa, this.id_oferta_formativa, this.user.id_institucional).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.resultado = (rs.data).filter((dt:any) => {

          const fecha = dt.fecha == null ?
          this.convierteDtpick(this.fechaActual) :
          this.convierteDtpick(formatDate(dt.fecha , 'dd-MM-yyyy', 'en-US'));

          console.log('sdsdsdsd:  ',dt.fecha)
          console.log('ooooooooo:  ',fecha)

          this.total += parseFloat(dt.porcentaje_evaluacion) || 0;

          this.plan_evaluacion.push(
            this.fb.group({
              id_logro: [dt.id_logro, Validators.required],
              fecha: [fecha, Validators.required],
              nombre: [dt.nombre, Validators.required],
              porcentaje_evaluacion: [dt.porcentaje_evaluacion, Validators.required],
              id_evaluacion: [dt.id_evaluacion],
            })
          )
          return dt;
        });

        console.log('Datos inicializados:', this.resultado);

        //this.filteredResultado = [...this.resultado]; // Inicializa los resultados filtrados con todos los datos
      },
      error: (error) => {
        this.errorMessage = error.message;
      },
    });
  }

  // La función ahora recibe el índice (i) y el nuevo valor (nuevoValorStr) como string
  calcula(index: number, nuevoValorStr: any){

    let totalSuma = 0;

    // 1. Convertir y actualizar el array 'resultado'
    // El valor se actualiza en el modelo ANTES de calcular.
    const nuevoValor = parseFloat(nuevoValorStr.value) || 0;
    this.resultado[index].porcentaje = nuevoValor;


    // 2. Calcular el total actual
    for (const item of this.resultado) {
      // Usamos el valor directamente del array que acabamos de actualizar
      const valorPorcentaje = parseFloat(item.porcentaje || 0);
      if (!isNaN(valorPorcentaje) && valorPorcentaje >= 0) { totalSuma += valorPorcentaje; }
    }

    // 3. Lógica de Validación (si el total excede 100)
    if (totalSuma > 100) {
      // Calculamos cuánto excedimos los 100 puntos
      const exceso = totalSuma - 100;
      // Revertimos el porcentaje del elemento modificado al valor máximo permitido
      const valorCorregido = nuevoValor - exceso;
      // 🚨 CRÍTICO: Actualizar el modelo de datos (this.resultado)
      this.resultado[index].porcentaje = valorCorregido > 0 ? valorCorregido : 0;
      this.plan_evaluacion.at(index).get('porcentaje_evaluacion')?.setValue(valorCorregido > 0 ? valorCorregido : 0)
      // Forzamos la suma total a 100 para la interfaz
      this.total = 100;
      // 🚨 CRÍTICO: Mostrar error en el modal (igual que antes)
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = "warning";
      this.letra_color = "dark";
      this.mensaje = `¡El valor máximo total es 100%! El porcentaje del Plan de Evaluación no puede superar ese límite.`;
      this.mdl.alerta();

    } else {
      // 4. Si el total es válido, simplemente actualizamos la variable total
      this.total = totalSuma;
    }

    console.log('Nuevo Total de Porcentaje:', this.total);
  }

  convierteDtpick(date: string):NgbDateStruct {
    // Asumiendo que tu string de entrada es 'DD-MM-YYYY'
    let array = date.split("-");
    return {
      year: parseInt(array[2]),
      month: parseInt(array[1]), // El NgbDateStruct usa meses 1-12
      day: parseInt(array[0])
    };
  }



  convertirStructAISO(date: NgbDateStruct): string {
    if (!date) {
      return '';
    }
    // Aseguramos el padding '0' para meses y días (ej: 9 -> 09)
    const year = date.year;
    const month = String(date.month).padStart(2, '0');
    const day = String(date.day).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  confirmacion(){
    this.formularioPlanEvaluacion.get('id_accion_formativa')?.setValue(this.id_accion_formativa);
    if(this.formularioPlanEvaluacion.valid){

      if(100 != this.total){
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = `EL porcentaje total debe ser igua a 100%, esta en ${this.total}!`;
        this.mdl.alerta();
      }
      else{
        let j = -1;
        ((this.formularioPlanEvaluacion.value).plan_evaluacion).forEach((dt:any) => {
          j += 1;
          const fecha: NgbDateStruct = this.plan_evaluacion.at(j).get('fecha')?.getRawValue();
          dt.fecha = this.convertirStructAISO(fecha);
        });
        this.mdl.confirma();
      }
    }
    else{
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = "Por favor complete todos los campos!";
      this.mdl.alerta();
    }
  }

  guardar_todo(){
    console.log('todos: ', this.formularioPlanEvaluacion.value)
    this.mdl.cargando();
    this.servicios.cargarplanEvaluacion(this.formularioPlanEvaluacion.value).subscribe({
      next: (rs) => {
        console.log('prueba:  ',rs)
        this.mdl.cerrar();
        this.vuelve.emit({value: false, validador: true, warning: 0});
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  volver(){
    this.vuelve.emit({value: false, validador: false, warning: 0});
  }

}
